// extracted by mini-css-extract-plugin
export default {"container":"SocialMedia_container__nWM18","logo":"SocialMedia_logo__JJN-8"};